<template>
  <b-form-group :disabled="changes_disabled">
    <unroll-element
      :title="$t('file_selection')"
      :available="true"
      :start_opened="true"
      :already_in_container="false"
    >
      <brick-file-subcomponent-file-selection
        v-model="files_infos_entities"
        :brick_id="brick_id"
        :project_id="project_id"
        :metavariables_dicts_poids="metavariables_dicts_poids"
      />
    </unroll-element>

    <unroll-element
      :title="$t('csv_format')"
      :available="true"
      :already_in_container="false"
    >
      <brick-file-subcomponent-csv-format
        v-model="csv_format_info"
        :brick_id="brick_id"
        :project_id="project_id"
        :metavariables_dicts_poids="metavariables_dicts_poids"
      />
    </unroll-element>

    <unroll-element
      :title="$t('csv_coercion')"
      :available="true"
      :already_in_container="false"
    >
      <brick-file-subcomponent-coercion-info-delta
        v-model="coercion_info_delta"
        :brick_id="brick_id"
        :project_id="project_id"
        :cur_brick_coercion_info_delta="cur_brick.coercion_info_delta"
        :metavariables_dicts_poids="metavariables_dicts_poids"
      />
    </unroll-element>

    <unroll-element
      :title="$t('hexa_preview')"
      :available="true"
      :already_in_container="false"
    >
      <brick-file-subcomponent-hexadecimal-viewer
        :brick_id="brick_id"
        :project_id="project_id"
        :metavariables_dicts_poids="metavariables_dicts_poids"
      />
    </unroll-element>
  </b-form-group>
</template>

<i18n>
{
  "en": {
    "file_selection": "File selection",
    "csv_coercion": "CSV coercion",
    "csv_format": "CSV format",
    "hexa_preview": "Hexadecimal preview"
  },
  "fr": {
    "file_selection": "Sélection du fichier",
    "csv_coercion": "Coercion du CSV",
    "csv_format": "Format du CSV",
    "hexa_preview": "Aperçu hexadécimal"
  }
}
</i18n>

<script>
import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment'

import { mapGetters } from 'vuex'

import {
  extended_dict_getValue,
  formatted_integer_with_thousand_spaces,
  formatted_moment_localized,
} from '@/utils.js'
import {
  generic_create,
  uploads_create,
  generic_delete,
  generic_update,
  file_brick_upload_completed,
} from '@/api/subscriptions.js'
import { GenericPath } from '@/components/object_model.js'

import { global_brick_mixin } from '@/components/mixin.js'
import BrickFileSubcomponentFileSelection from '@/components/brick_file_subcomponent_file_selection.vue'
import BrickFileSubcomponentCsvFormat from './brick_file_subcomponent_csv_format.vue'
import BrickFileSubcomponentCoercionInfoDelta from './brick_file_subcomponent_coercion_info_delta.vue'
import BrickFileSubcomponentHexadecimalViewer from './brick_file_subcomponent_hexadecimal_viewer.vue'

import ValidationButtonsBar from '@/components/validation_buttons_bar.vue'
import FilepathSelector from '@/components/filepath_selector.vue'
import FileUploader from '@/components/file_uploader.vue'
import UnrollElement from './unroll_element.vue'

// *****************************************************************************

export default {
  name: 'BrickFile',
  components: {
    BrickFileSubcomponentFileSelection,
    BrickFileSubcomponentCsvFormat,
    BrickFileSubcomponentCoercionInfoDelta,
    BrickFileSubcomponentHexadecimalViewer,
    ValidationButtonsBar,
    UnrollElement,
  },
  mixins: [global_brick_mixin],
  data() {
    return {
      csv_format_info: undefined,
      coercion_info_delta: undefined,
      files_infos_entities: undefined,
    }
  },

  computed: {
    adapted_data() {
      let adapted = {
        uid: this.brick_id,
        csv_format_info: _.cloneDeep(this.csv_format_info),
        coercion_info_delta: _.cloneDeep(this.coercion_info_delta),
        files_infos_entities: _.cloneDeep(this.files_infos_entities),
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      async handler(nv) {
        this.csv_format_info = _.cloneDeep(nv.csv_format_info)
        this.coercion_info_delta = _.cloneDeep(nv.coercion_info_delta)
        this.files_infos_entities = _.cloneDeep(nv.files_infos_entities)
      },
    },
  },
}
</script>
